import { JSX } from "react";
import { Outlet } from "react-router-dom";

import Container from "@mui/material/Container";

import MenuBar from "menu/MenuBar";
import CookieBanner from "./CookieBanner";

export default function Page(): JSX.Element {
	return (
		<>
			<MenuBar />
			<Container
				aria-label="page-content"
				sx={{ paddingTop: 3, paddingBottom: 3 }}>
				<Outlet />
			</Container>
			<CookieBanner />
		</>
	);
}
